import {Amplify} from 'aws-amplify';
import {
  InitWithAmplify,
  InitEnvironmentVariable,
  QuestionsService as PikadoQuestionsService,
} from '@PikaDoApp/npm-pikado-logic';
import type {
  newQuestionInsert,
  newUpdateQuestionInput,
} from '@PikaDoApp/npm-pikado-logic/dist/modules/question/graphql/question.interface';
import {IQuestionsRepository} from './IQuestionsRepository';
import {getEnvironment} from '../../lib/getEnvironment';

// Initialize the Pikado Logic package
InitWithAmplify(Amplify);
InitEnvironmentVariable(getEnvironment());

// Create QuestionsService instance
const pikadoQuestionsService = new PikadoQuestionsService();

export class QuestionsNewRepository implements IQuestionsRepository {
  async createQuestion(question: newQuestionInsert): Promise<any> {
    try {
      // Using @PikaDoApp/npm-pikado-logic package
      const createdQuestion = await pikadoQuestionsService.newCreateQuestion(question);

      if (!createdQuestion) {
        return null;
      }

      // Transform created question to match UI expectations
      // Map _id to id for UI compatibility
      const transformedQuestion = {
        id: createdQuestion._id,
        _id: createdQuestion._id,
        questionText: createdQuestion.questionText,
        AiText: createdQuestion.AiText,
        type: createdQuestion.type,
        description: createdQuestion.description,
        difficulty: createdQuestion.difficulty,
        createdBy: createdQuestion.createdBy,
        createdAt: createdQuestion.createdAt,
        updatedAt: createdQuestion.updatedAt,
      };

      return transformedQuestion;
    } catch (error) {
      console.error('🔍 [QUESTION-NEW-PACKAGE] createQuestion repository Error:', error);
      throw error instanceof Error ? error : new Error(String(error));
    }
  }

  async updateQuestion(
    id: string,
    question: newUpdateQuestionInput,
    updatedAt?: string,
  ): Promise<any> {
    try {
      // Using @PikaDoApp/npm-pikado-logic package
      const updatedQuestion = await pikadoQuestionsService.newUpdateQuestion(id, question);

      if (!updatedQuestion) {
        return null;
      }

      // Transform updated question to match UI expectations
      const transformedQuestion = {
        id: updatedQuestion._id,
        _id: updatedQuestion._id,
        questionText: updatedQuestion.questionText,
        AiText: updatedQuestion.AiText,
        type: updatedQuestion.type,
        description: updatedQuestion.description,
        difficulty: updatedQuestion.difficulty,
        createdBy: updatedQuestion.createdBy,
        createdAt: updatedQuestion.createdAt,
        updatedAt: updatedQuestion.updatedAt,
      };

      return transformedQuestion;
    } catch (error) {
      console.error('🔍 [QUESTION-NEW-PACKAGE] updateQuestion repository Error:', error);
      throw error instanceof Error ? error : new Error(String(error));
    }
  }

  async getQuestionById(id: string): Promise<any> {
    try {
      // Using @PikaDoApp/npm-pikado-logic package
      const question = await pikadoQuestionsService.getQuestionById(id);

      if (!question) {
        return null;
      }

      // Transform question to match UI expectations
      const transformedQuestion = {
        id: question._id,
        _id: question._id,
        name: question.name,
        summary: question.summary,
        questionText: question.questionText,
        AiText: question.AiText,
        type: question.type,
        description: question.description,
        difficulty: question.difficulty,
        createdBy: question.createdBy,
        createdAt: question.createdAt,
        updatedAt: question.updatedAt,
        payload: question.payload,
      };

      return transformedQuestion;
    } catch (error) {
      console.error('🔍 [QUESTION-NEW-PACKAGE] getQuestionById repository Error:', error);
      throw error instanceof Error ? error : new Error(String(error));
    }
  }

  async deleteQuestion(id: string): Promise<any> {
    try {
      // Using @PikaDoApp/npm-pikado-logic package
      const result = await pikadoQuestionsService.deleteQuestion(id);

      return {
        success: true,
        message: 'Question deleted successfully',
        deletedId: id,
        result,
      };
    } catch (error) {
      console.error('🔍 [QUESTION-NEW-PACKAGE] deleteQuestion repository Error:', error);
      throw error instanceof Error ? error : new Error(String(error));
    }
  }
}
